import { apiGet, apiPost, apiDelete } from './client.js';

export function requestUploadUrl(projectId, filename, contentType) {
  return apiPost(`/api/projects/${projectId}/uploads/request`, { filename, content_type: contentType });
}
export function confirmUpload(projectId, assetId) {
  return apiPost(`/api/projects/${projectId}/uploads/${assetId}/confirm`);
}
export function listAssets(projectId) { return apiGet(`/api/projects/${projectId}/assets`); }
export function deleteAsset(projectId, assetId) { return apiDelete(`/api/projects/${projectId}/assets/${assetId}`); }

export function uploadFileToGCS(uploadUrl, file, onProgress) {
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.open('PUT', uploadUrl);
    xhr.setRequestHeader('Content-Type', file.type);
    if (onProgress) {
      xhr.upload.onprogress = (e) => {
        if (e.lengthComputable) onProgress(Math.round((e.loaded / e.total) * 100));
      };
    }
    xhr.onload = () => (xhr.status >= 200 && xhr.status < 300 ? resolve() : reject(new Error(`Upload failed: ${xhr.status}`)));
    xhr.onerror = () => reject(new Error('Upload network error'));
    xhr.send(file);
  });
}
